import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="fullscreen"
export default class extends Controller {
  static values = {
    enabled: {type: Boolean, default: false}
  }

  connect() {
    document.addEventListener("fullscreenchange", () => {
      if (!document.fullscreenElement) {
        this.enabledValue = false
      }
    })
  }

  toggle() {
    this.enabledValue = !this.enabledValue
  }

  enabledValueChanged() {
    if (this.enabledValue) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen()
      } else {
        alert("Your browser does not support fullscreen mode.")
        this.enabledValue = false
      }
    } else {
      if (document.fullscreenElement) {
        document.exitFullscreen()
      }
    }
  }
}
